<template>
  <div :class="{ header: true, fixs: isFixeds }">
    <div class="flexible font-MT jc-center" :class="{ center: true, clearfix: true, bigheader: isbig }">
      <div class="logo">
          <img @click="goHome()" src="@/assets/logo.png" alt="logo"/>
      </div>
      <ul class="nav-left">
        <li v-for="(item, index) in nav_left" :key="item.name">
          <router-link v-if="item.url" :to="item.url"
            >{{ item.name }} <span class="line"></span
          ></router-link>
          <el-dropdown trigger="hover" v-if="!item.url && !language" class="lang-change" placement="bottom" @command="handleCommand">
            <span class="el-dropdown-link f16">
              {{languageValue?languageValue:item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="lang-select">
              <el-dropdown-item command="en_US">English</el-dropdown-item>
              <!-- <el-dropdown-item command="en_ID" style="border-bottom: none!important">Indonesia</el-dropdown-item> -->
              <!-- <el-dropdown-item command="zh_CN">中文</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
      <ul class="nav-right flexible aItem-center">
        <li
          class="loginsmall"
        >
          <el-popover
                  v-if="token != null"
                  placement="bottom"
                  title=""
                  width="120"
                  popper-class="logoutCon"
                  :append-to-body="false"
                  trigger="hover">
                  <div class="logout-drop-item">
                    <a class="logout-item text-333 f14 font-MT" href="javascript:" @click="logout">
                      <i class="el-icon-switch-button f-fwb"></i>
                      <span class="ml0">{{$lang('login.logoutbtn')}}</span>
                    </a>
                  </div>
                <div slot="reference" class="myheaderimg f14 font-MT f-fwb text-fff f-tac f-csp" @click="goAuthor">BG</div>
              </el-popover>
          <div v-else class="nologin f-tac f14 font-MT" @click="gologin()">
            <a href="javaScript:">{{$lang('login.loginbtn')}}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getToken } from "utils/storage";
import { mapState } from "vuex";
export default {
  props: {
    isbig: {
      type: Boolean,
      default: false
    },
    isAuthor: Boolean,
    isToken: String,
    language: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      nav_left: [],
      currentRouter: {},
      qqurl: "",
      weixinLogin: "",
      isFixeds: false,
      isshowInfo: true,
      isShowRight: false,
      token: getToken() || null,
      searchValue: null,
      languageValue: ''
    };
  },
  computed: mapState({
    imgurl: state => state.user.img
  }),
  created() {
    if (this.$i18n.locale == 'en_ID') {
      this.languageValue = 'Indonesia';
    } else if (this.$i18n.locale == 'zh_CN') {
      this.languageValue = '中文';
    } else {
      this.languageValue = 'English';
    };
    this.nav_left = [
      {
        name: this.$lang('header.home'),
        url: "/"
      },
      {
        name: this.$lang('header.create'),
        url: "/Create/0"
      },
      {
        name: this.$lang('header.benefits'),
        url: "/welfare"
      },
      {
        name: this.$lang('header.lang'),
      }
    ];
  },
  mounted() {
    let _this=this;
    window.addEventListener("setItemEvent",function(e){
      if(e.key==="rock-Token"){
        _this.token = e.newValue;
      }
    })
    window.addEventListener("scroll",this.handleScroll, true)
  },
  methods: {
    gologin() {
      this.$emit('changeLogin', true)
    },
    goAuthor () {
      this.$router.push('/author')
    },
    goHome () {
      this.$router.push('/')
    },
    /* 退出 */
    logout() {
      this.$store.dispatch('LogOut').then((res) => {
        console.log(res)
        if (res.success) {
          this.$success('custom', this.$lang('alert.sucAlert[4]'))
          this.token = getToken() || null
          location.reload()
        }
      })
    },
    // ==吸顶
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 210) {
        //提前判断要上升多少像素就固定
        this.isFixeds = true;
      } else {
        this.isFixeds = false;
      }
    },
    goBoxValue() {
      this.$router.push({
        path: "/bookStack",
        query: { searchValue: this.searchValue }
      });
      this.searchValue = null;
    },
    handleCommand(command) {
      localStorage.setItem('language', command);
      this.$i18n.locale = command; // 修改页面需要显示的语言
      if (this.$i18n.locale == 'en_ID') {
        this.languageValue = 'Indonesia';
        this.$router.go(0);
      } else if (this.$i18n.locale == 'zh_CN') {
        this.languageValue = '中文';
        this.$router.go(0);
      } else {
        this.languageValue = 'English';
        this.$router.go(0);
      };
    }
  },


};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  @media (max-width: 768px) {
    overflow-x: auto;
  }
  &.fixs{
    position: fixed;
    top: 0;
    width: 100%;
    z-index:1;
    background: rgba(22,22,31,0.9);
  }
  .center {
    margin: 0 auto;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #fff;
    position: relative;
    width: 1400px;
    .logo {
      width: 262px;
      height: 48px;
      line-height: 60px;
      img {
        vertical-align: middle;
        width: 262px;
        height: 48px;
      }
    }
    .nav-left {
      margin-left: 287px;
      li {
        display: inline-block;
        position: relative;
        margin-right: 50px;
        a {
          display: inline-block;
          color: #fff;
          font-size: 16px;
          font-weight: 500;
          &.router-link-exact-active {
            color: #FF049B;
            .line{
              width:50px;
              height: 4px;
              border-radius: 3px;
              background: #FF049B;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);

            }
          }
          &:hover {
            color: #FF049B;
          }
        }
        .lang-change{
          font-size: 18px;
          color: #fff;
          cursor: pointer;
          &:hover{
            color: #FF049B;
          }
        }
      }
    }

    .nav-right {
      li {
        .nologin {
          width: 120px;
          height: 40px;
          line-height: 40px;
          background: #33333A;
          border-radius: 20px;
          cursor: pointer;
          font-size: 14px;
          text-align: center;
          color: #fff;
          a{
            color: #fff;
          }
        }
        .myheaderimg {
          width: 40px;
          height: 40px;
          line-height: 40px;
          border-radius: 50%;
          background: #33333A;
          outline: none;
        }
      }
    }
  }
}


</style>
<style lang="scss">
  .lang-select{
    width: 150px!important;
    background: #33333A!important;
    border-radius: 6px;
    padding: 0;
    border: none;
    box-shadow: none;
    top: 50px!important;
    .popper__arrow{
        display: none!important;
    }
    .el-dropdown-menu__item{
      height: 44px!important;
      line-height: 44px!important;
      font-size: 14px!important;
      color: #fff!important;
      padding: 0!important;
      text-align: center!important;
      border-bottom: 1px solid #41414D!important;
      &:hover {
        color: #FF049B!important;
        background: none;
      }
    }
  }
  .logoutCon {
    width: 122px !important;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1) !important;
    padding:0!important;
    border-radius: 8px;
    margin-top: 20px!important;
    min-width: 122px;
    .logout-item{
      width: 122px;
      display: block;
      margin: 0;
      height: 30px;
      line-height: 30px;
      text-align: center;
    }
  }
</style>
